import { render, staticRenderFns } from "./SectorForm.vue?vue&type=template&id=365d6b5a&"
import script from "./SectorForm.vue?vue&type=script&lang=js&"
export * from "./SectorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports